import MatchCenter from "../../components/matchCenter";

export default function MatchCenterPage() {
  return <MatchCenter />;
}
